export class BootScene extends Phaser.Scene {
    constructor() {
        super({
            key: 'BootScene',
        });
    }

    public preload() {

    }
    public onResize = function () {
    };
    public create() {
        //this.game.plugins.screenShake = this.game.plugins.add(Phaser.Plugin.ScreenShake);
        this.game.scene.start('PreloadScene');
        //window.addEventListener('resize', this.onResize.bind(this));
    
    }

}
